import {Directive, ElementRef, Input, OnInit, inject} from '@angular/core';
import {ApiService} from "../services/api.service";
import {UserService} from "../services/user.service";

@Directive({
  selector: '[appVideoSrc]',
  standalone: true
})
export class VideoSrcDirective implements OnInit {
  private apiService: ApiService = inject(ApiService);
  private userService: UserService = inject(UserService);
  private el: ElementRef = inject(ElementRef);

  @Input() public fileName: string | undefined = undefined;

  public ngOnInit(): void {
    this.el.nativeElement.src = this.apiService.getUrl() + this.fileName + '?token=' + this.userService.getStoredUserToken();
  }

}
